module.exports = __webpack_public_path__ + "img/order-cancelled.c44523eb.svg";